import React from 'react';
import OurServices from "../Home/components/Services"

const Services = () => {
  return <div>
    <OurServices />
  </div>;
};

export default Services;
